export default "__VITE_ASSET__ff8d7b59__"